/* Copyright (c) Trimble Inc. All rights reserved. */

import { SvgIcon, SvgIconProps, useTheme } from '@material-ui/core';
import React, { memo } from 'react';

export const EmailIcon: React.FC<SvgIconProps> = (props) => {
  const { palette } = useTheme();
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 47 33"
      fill="none"
    >
        <rect x="0.5" y="0.5" width="44.8038" height="32" rx="3.5" fill={palette.background.paper} stroke={palette.primary.dark}/>
        <path d="M0.917969 2L20.6143 18.7595C22.1264 20.0462 24.3534 20.029 25.8454 18.7191L44.8896 2" fill={palette.background.paper} stroke={palette.primary.dark}/>
        <line y1="-0.5" x2="23.0582" y2="-0.5" transform="matrix(0.794579 -0.607161 0.539802 0.841792 1.83203 32)" stroke={palette.primary.dark}/>
        <path d="M44.2656 31.0449L28.8587 15.9993" stroke={palette.primary.dark}/>
    </SvgIcon>
  );
};

export default memo(EmailIcon);
